import { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import * as dayjs from 'dayjs';
import Geocode from "react-geocode";
import ReactGA from 'react-ga4';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import "@fontsource/poppins";

import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import AppRoutes from './routes';
import Zendesk from './utils/zendesk';
import { store } from './store';
import { customTheme } from './theme/css/mui';
import { bootStorage } from './helpers/bootStorage';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './services/react-query/react-query.client';
import {GOOGLE_API_KEY} from "./constants/google-map.constants";
import { SessionSyncListener } from './components/session-sync-listener';
import {
  LoadScriptNext
} from '@react-google-maps/api';

dayjs.locale('en');

Geocode.setApiKey("AIzaSyDUOkjPoIuDvIYhiLbtwKoFu1o8QMFlhF4");
Geocode.setLanguage("en");
Geocode.setRegion("en");
Geocode.setLocationType("ROOFTOP");

ReactGA.initialize('G-B1ER8477MH');

// Define libraries outside component to prevent re-initialization
const libraries: ("places" | "geometry")[] = ["places", "geometry"];

function App() {
  useEffect(() => {
    bootStorage();

    Zendesk.initialize();
  }, []);

  const theme = useMemo(() => customTheme, [customTheme]);

  return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <StyledThemeProvider theme={theme}>
            <ThemeConfig>
              <GlobalStyles />
              <QueryClientProvider client={queryClient}>
                <SessionSyncListener />
                <LoadScriptNext
                    googleMapsApiKey={GOOGLE_API_KEY}
                    libraries={libraries}
                >
                  <AppRoutes />
                </LoadScriptNext>
              </QueryClientProvider>
              <ToastContainer />
            </ThemeConfig>
          </StyledThemeProvider>
        </ThemeProvider>
      </Provider>
  );
}

export default App;
